<!--
 * @Author: your name
 * @Date: 2021-09-13 20:16:04
 * @LastEditTime: 2022-03-27 13:34:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zip1111\src\components\HelloWorld.vue
-->
<template>
  <div class="bounty-header">
    <div class="logo" @click="goIndex">
      <img src="../../assets/Index/logo.png" alt="img" class="logo-img">
    </div>
    <div class="header-right">
      <div class="createTask" v-if="account">
        <svg @click="goMyCreateTask" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="20" fill="url(#paint0_linear)"/>
          <path d="M10 20H30" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M20 10L20 30" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          <defs>
          <linearGradient id="paint0_linear" x1="0" y1="0" x2="42.3346" y2="2.64591" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A737FF"/>
          <stop offset="1" stop-color="#18D6BE"/>
          </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="logout" v-if="!account">
        <div class="connect-wallet" @click="connetWallet">{{$t("Index.wallet")}}</div>
      </div>
      <div class="login" @click="goMy" v-else>
        <div class="login-icon" v-if="!headPortrait">
          <div class="login-red-box"></div>
        </div>
        <img v-else :src="headPortrait" alt="img">
        <div v-if="false" class="red-point"></div>
      </div>
      <div  @click="changeLanguage" class="language cancelselect">{{lang}}</div>
      <!-- <div v-if="false" @click="changeLanguage" class="language cancelselect">{{lang}}</div> -->
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/plugin/eventBus/index.js'
import dayjs from 'dayjs'
import { format } from 'js-conflux-sdk'
import { getToken, getMyProfile } from '@/api/bounty.js'
export default {
  name: 'bountyHeader',
  props: {
  },
  data () {
    return {
      lang: 'EN',
      isLogin: false,
      account: '', // 钱包地址
      timer: '', // 检测钱包是否安装轮询
      headPortrait: ''
    }
  },
  created () {
    eventBus.$on('changeConnect', () => {
      this.account = ''
    })
    eventBus.$on('refreshTime', () => {
      // 更新钱包时间
      localStorage.setItem('nowTime', new Date())
      this.openPortal(false) // 只更新时间
    })
    eventBus.$on('openWallet', () => {
      // 打开钱包链接
      this.openPortal()
    })
  },
  mounted () {
    if (sessionStorage.getItem('walletAddress')) {
      // this.account = sessionStorage.getItem('walletAddress')
      // 清楚缓存
      this.openPortal()
    } else {
      this.account = ''
      clearTimeout(this.timer)
    }
    if (localStorage.getItem('languageBounty') === 'cn') {
      this.lang = '中文'
      this.$i18n.locale = this.lang === '中文' ? 'cn' : 'en'
      this.changeLanguageEvent()
    }
  },
  methods: {
    /**
     * @description: 去我的页面创建任务
     * @param {*}
     * @return {*}
     */
    goMyCreateTask () {
      if (Number(sessionStorage.getItem('pandaStatus')) !== 1) { // 无pandaid
        this.$message({
          type: 'warning',
          offset: 120,
          message: this.$t('Skills.skilPandaId.tip2')
        })
      } else {
        if (this.$route.name === 'My') {
          eventBus.$emit('createTask')
        } else {
          this.$router.push({ name: 'My', params: { showCreateTask: true } })
        }
      }
    },
    /**
     * @description: 修改语言
     * @param {*}
     * @return {*}
     */
    changeLanguage () {
      this.lang = this.lang === 'EN' ? '中文' : 'EN'
      this.$i18n.locale = this.lang === '中文' ? 'cn' : 'en'
      localStorage.setItem('languageBounty', this.$i18n.locale)
      this.changeLanguageEvent()
    },
    /**
     * @description: 修改语言事件
     * @param {*}
     * @return {*}
     */
    changeLanguageEvent () {
      document.getElementsByTagName('body')[0].style.setProperty('--test', this.lang === '中文' ? 'PingFang Regular' : 'Circular Std')
      eventBus.$emit('createProjectTaskDictChange')
      eventBus.$emit('createProjectDictChange')
      eventBus.$emit('changeIndexSwiperArr')
    },
    /**
     * @description: 去首页
     * @param {*}
     * @return {*}
     */
    goIndex () {
      this.$router.push({ name: 'Index' })
    },
    /**
     * @description: 去我的页面
     * @param {*}
     * @return {*}
     */
    goMy () {
      console.log(this.$route.name)
      if (this.$route.name === 'My') {
        eventBus.$emit('showMyList')
      } else {
        this.$router.push({ name: 'My' })
      }
      // if (this.$route)
    },
    /**
     * @description: 实时检查插件状态
     * @param {*}
     * @return {*}
     */
    async queryCapitalInfo () {
      if (this.checkPortal()) {
        try {
          if (sessionStorage.getItem('walletAddress')) {
            this.account = conflux.selectedAddress
          } else {
            clearTimeout(this.timer)
            this.timer = null
            this.account = ''
          }
        } catch (err) {
          this.$message.warning(err)
          clearTimeout(this.timer)
          this.timer = null
          this.account = ''
          window.sessionStorage.clear()
          this.$router.push({ name: 'Index' }) // 回首页重新登录
        }
      } else {
        this.$message.warning(this.$t('Index.header.walletTip'))
        clearTimeout(this.timer)
        this.timer = null
        this.account = ''
        window.sessionStorage.clear()
        this.$router.push({ name: 'Index' }) // 回首页重新登录
      }
    },
    /**
     * @description: 打开钱包
     * @param {*}
     * @return {*}
     */
    async openPortal (flag = true) {
      // const CONTRACT_ADDRESS = format.hexAddress('cfxtest:acen1k28j5y8knyk3reez7n26ydxbhg3ujahuy8gag') // 测试
      const CONTRACT_ADDRESS = format.hexAddress(CONTRAC_ADRESS_BONTY) // 正式
      // console.log(CONTRACT_ADDRESS, 'CONTRACT_ADDRESS')
      if (this.checkPortal()) {
        try {
          // 设置合约
          this.$root.contract = confluxJS.Contract({
            abi: CONTRACT_ABI,
            address: CONTRAC_ADRESS_BONTY
          })
          clearTimeout(this.timer)
          this.timer = null
          // 打开钱包
          const accounts = await conflux.request({ method: 'cfx_requestAccounts' }) // 打开钱包

          // 定时检测钱包安装状态 钱包登录时间是 5分钟
          let timesPass = 0
          if (localStorage.getItem('nowTime')) {
            timesPass = dayjs(new Date()).diff(dayjs(localStorage.getItem('nowTime')), 'second')
            console.log('timesPass', timesPass)
          } else {
            localStorage.setItem('nowTime', new Date())
          }
          this.timer = setTimeout(async () => {
            // if (this.$route.name === 'My') {
            //   this.$router.push({ name: 'Index' })
            // }
            // clearTimeout(this.timer)
            // this.timer = null
            // this.account = ''
            // window.sessionStorage.clear()
            // localStorage.clear()
            // localStorage.setItem('languageBounty', this.$i18n.locale)
          }, 300000 - timesPass * 1000)
          // 定时检测钱包安装状态 钱包登录时间是 5分钟

          // 请求token
          let resToken
          if (flag) {
            resToken = await getToken({
              walletAddress: accounts[0]
            })
            if (!resToken.code) {
              console.log('accounts', accounts)
              this.account = accounts[0]// 钱包地址
              sessionStorage.setItem('walletAddress', this.account)
              sessionStorage.setItem('bountyToken', resToken.token)
              // 注册个人信息
              setTimeout(async () => {
                const userInfo = await getMyProfile()
                console.log('userInfo', userInfo.data.profile)
                sessionStorage.setItem('userInfo', JSON.stringify(userInfo.data.profile))
                sessionStorage.setItem('pandaStatus', userInfo.data.profile.pandaStatus)
                sessionStorage.setItem('country', userInfo.data.profile.country)
                eventBus.$emit('checkEnvSkills')
                this.headPortrait = userInfo.data.profile.headPortrait || ''
              }, 10)
            }
          }
        } catch (error) {
          this.$message.error(error)
        }
      } else {
        window.sessionStorage.clear()
        this.$message.warning(this.$t('Index.header.walletTip'))
      }
    },
    /**
     * @description: 检测是否安装 11
     * @param {*}
     * @return {*}
     */
    checkPortal () {
      if (!window.conflux) {
        return false
      } else {
        return true
      }
    },
    /**
     * @description: 连接钱包
     * @param {*}
     * @return {*}
     */
    async connetWallet () {
      this.openPortal()
      // const resToken = getToken({
      //   walletAddress: 'cfx:aatds0g82rhw8ze6497cmpuk9reft8uu9jj15xcgpu'
      // })
      // getMyProfile
      // getToken({
      //   walletAddress: 'cfx:aatds0g82rhw8ze6497cmpuk9reft8uu9jj15xcgpu'
      // }).then(res => {
      //   console.log(res)
      // }).catch(err => {
      //   console.log('err==> ', err)
      // })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/gloabal.scss';
.createTask{
  margin-right: 24px;
  cursor: pointer;
  svg{
    width: 40px;
    height: 40px;
  }
}
.bounty-header{
  background: linear-gradient(90deg, #26252B 0%, #26272A 100%);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 8;
  height: 94px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  // position: fixed;
  padding: 0 120px;
  padding-top: 40px;
  .logo {
    cursor: pointer;
    font-family: $fontFamilyCircularStd;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 36px;
    color: #fff;
    img{
      width: 130px;
      height: 52px;
      margin-top: -6px;
    }
  }
  .header-right{
    display: flex;
  }
  .logout{
    display: flex;
    justify-content: space-between;
    .connect-wallet{
      width: 153px;
      height: 40px;
      border: 1px solid #18D6BE;
      border-radius: 26px;
      line-height: 40px;
      color: #18D6BE;
      font-family: $fontFamilyCircularStd;
      font-size: 16px;
      text-align: center;
      cursor: pointer;
      // margin-right: 44px;
    }
  }
  .language{
    font-family: $fontFamilyCircularStd;
    font-size: 16px;
    line-height: 40px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    border: 1px solid #fff;
    text-align: center;
    margin-left: 24px;
  }
  .login{
    display: flex;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
    // margin-right: 24px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    img{
      width: 40px;
      height: 40px;
      border-radius: 100%;
    }
    .login-icon{
      width: 40px;
      height: 40px;
      background: #F8DE94;
      border-radius: 100%;
      position: relative;
      overflow: hidden;
      .login-red-box{
        position: absolute;
        width: 37px;
        height: 37px;
        background: #EE82A0;
        border: 5px solid #E45564;
        top: 12px;
        left: 12px;
        border-radius: 100%;
      }
    }
    .red-point{
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
